import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ActionProvider } from './actions';
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ActionProvider>
      <App />
    </ActionProvider>
  </React.StrictMode>
);